import React from 'react';
import { PlayIcon, StarIcon, WrenchIcon } from 'lucide-react';
import { yearPlan } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** One color per part of the school year (full class names so Tailwind keeps them). Dark text on gold for contrast. */
const quarterStyles = [{
  band: 'bg-sun text-ink',
  star: 'text-ink'
}, {
  band: 'bg-coral text-white',
  star: 'text-coral-ink'
}, {
  band: 'bg-violet text-white',
  star: 'text-violet-ink'
}, {
  band: 'bg-brand text-white',
  star: 'text-brand'
}];

/** The school show year: ★ shows and ▶ start-rehearsing dates */
export function YearPlanSection() {
  return <section id="year" aria-labelledby="year-title" className="scroll-mt-4 bg-white py-12 md:py-20" data-id="element-290" data-mp="32juag8zh6c7e">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-291" data-mp="37d6nrmypewku">
        <SectionHeading id="year-title" eyebrow={yearPlan.eyebrow} title={yearPlan.title} sub={yearPlan.sub} data-id="element-292" data-mp="29x9hx579ju29" />

        <ol className="mt-8 grid gap-4 md:mt-12 md:grid-cols-2 lg:grid-cols-4" data-id="element-293" data-mp="2euj6yjqqq3pk">
          {yearPlan.quarters.map((q, qi) => {
          const s = quarterStyles[qi % quarterStyles.length];
          return <li key={q.q} className="flex flex-col overflow-hidden rounded-xl border border-hair bg-white" data-id="element-294" data-mp="1vb6957c293oe" data-mpi={qi}>
                <div className={`flex items-baseline justify-between gap-3 px-5 py-3 ${s.band}`} data-id="element-295" data-mp="1qi3aiksff41c">
                  <span className="font-display text-[1.25rem] font-black leading-none" data-id="element-296" data-mp="1lkl534dmb6y3">{q.q}</span>
                  <span className="font-display text-[12px] font-extrabold tracking-[0.1em]" data-id="element-297" data-mp="1gn1m5r5z65zt">{q.weeks}</span>
                </div>
                <div className="flex flex-1 flex-col p-5" data-id="element-298" data-mp="17ksf5b9x0ur6">
                  <h3 className="font-display text-[16px] font-black tracking-[0.04em] text-ink" data-id="element-299" data-mp="17lbymwf7rr7b">{q.name}</h3>
                  <ul className="mt-4 space-y-3" data-id="element-300" data-mp="12o210tho898e">
                    {q.full.map(m => {
                  const start = 'review' in m && m.review;
                  const Icon = start ? PlayIcon : StarIcon;
                  return <li key={`${q.q}-${m.when}-${m.label}`} className="flex gap-3" data-id="element-301" data-mp="3g4d48wi842ow">
                          <Icon className={`mt-0.5 h-4 w-4 shrink-0 fill-current ${start ? 'text-sky-ink' : s.star}`} aria-hidden="true" data-id="element-302" data-mp="3kvva9yz3stgq" />
                          <div className="min-w-0" data-id="element-303" data-mp="375i1xviavcqv">
                            <p className="text-[11px] font-bold tracking-[0.1em] text-ink/55" data-id="element-304" data-mp="3c2i6u33ey9ge">
                              {m.when} · {m.label}
                            </p>
                            <p className={`font-display text-[15px] font-bold leading-snug ${start ? 'text-sky-ink' : 'text-brand'}`} data-id="element-305" data-mp="7othmgc25iit">{m.title}</p>
                          </div>
                        </li>;
                })}
                  </ul>
                  <p className="mt-auto pt-4 text-[14px] leading-snug text-ink/70" data-id="element-306" data-mp="3uroix79pc2t8">{q.activities}</p>
                </div>
              </li>;
        })}
        </ol>
        <p className="mt-4 text-center text-[13px] text-ink/60" data-id="element-307" data-mp="2jf5knu1603nm">{yearPlan.southNote}</p>

        <div className="mx-auto mt-6 max-w-[900px] rounded-xl bg-sun-soft p-5 md:mt-8 md:p-6" data-id="element-308" data-mp="2bts9boeblg0x">
          <div className="flex items-center gap-3" data-id="element-309" data-mp="26wjr5nt69bzo">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sun text-ink" data-id="element-310" data-mp="26y34b5jj76x8">
              <WrenchIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" data-id="element-311" data-mp="2fwf4nza79j2v" />
            </span>
            <h3 className="font-display text-[14px] font-black tracking-[0.08em] text-ink" data-id="element-312" data-mp="1s6uaek8lizea">{yearPlan.toolsTitle}</h3>
          </div>
          <ul className="mt-4 grid gap-2.5 md:grid-cols-3 md:gap-4" data-id="element-313" data-mp="1o6ac3dcadpqk">
            {yearPlan.tools.map(t => <li key={t} className="rounded-lg bg-white px-4 py-3 text-[15px] font-medium leading-snug text-ink" data-id="element-314" data-mp="21xfeuoayay54">
                {t}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}